const BASE_URL = '/api';

export const getkycApi = BASE_URL + '/kyc';

export const uploadkycApi = BASE_URL + '/kyc';

export const wishlistApi = BASE_URL + '/wishlist';

export const viewlistApi = BASE_URL + '/viewlist';

export const getuserdata = BASE_URL + '/getuserdata';

export const userinvested = BASE_URL + '/userinvested';

export const userlaunchpad = BASE_URL + '/userlaunchpad';

export const createuserApi = BASE_URL + "/createuser";

export const gettrending = BASE_URL + "/gettrending";

export const gethomecalculation = BASE_URL + "/gethomecalculation";

export const getsaleApi = BASE_URL + "/getsale";

export const addkycauditApi = BASE_URL + "/addkycaudit"

export const getallsaleApi = BASE_URL + "/getallsale"

export const getusecreatedlaunchApi = BASE_URL + "/getusecreatedlaunch";

export const updatelaunchpadApi = BASE_URL + "/updatelaunchpad";

export const claimAirdrop = BASE_URL + "/claimAirdrop";

export const getclaimedUsers =  BASE_URL + "/getclaimedUsers";